"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NotificationBanner__vue_1 = __importDefault(require("@becrop/components/Common/NotificationBanner .vue"));
const User_1 = __importDefault(require("@common/models/User"));
const LaravelAPIPaginator_1 = __importDefault(require("@common/tsutils/LaravelAPIPaginator"));
const vue_property_decorator_1 = require("vue-property-decorator");
const Sample_1 = __importDefault(require("@common/models/Sample"));
const Crop_1 = __importDefault(require("@common/models/Crop"));
const NumberReports_vue_1 = __importDefault(require("@becrop/components/ReportsComponent/NumberReports.vue"));
const Search_vue_1 = __importDefault(require("@becrop/components/Common/Search.vue"));
const TableReports_vue_1 = __importDefault(require("@becrop/components/ReportsComponent/TableReports.vue"));
const ReportsFooter_vue_1 = __importDefault(require("@becrop/components/ReportsComponent/ReportsFooter.vue"));
const HelpGuide_vue_1 = __importDefault(require("@becrop/components/Common/HelpGuide.vue"));
const SearchOptions_vue_1 = __importDefault(require("@becrop/components/Common/SearchOptions.vue"));
const ZeroView_vue_1 = __importDefault(require("@becrop/components/Common/ZeroView.vue"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Common/ViewZero.vue"));
const Distributor_vue_1 = __importDefault(require("@becrop/components/Common/Distributor.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Common/Loader.vue"));
const moment_1 = __importDefault(require("moment"));
const DistributorBanner_vue_1 = __importDefault(require("@becrop/components/Common/DistributorBanner.vue"));
//A priori falta la lista de subclientes si es distribuidor y en la vista
// original dentro del objeto becrop_report hay un campo de 'version' que utilizamos para triggerear
// el badge de New 2.0, y que tampoco esta (edited)
let ReportsView = class ReportsView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.user = null;
        this.samples = [];
        this.crops = [];
        this.would_rather_crops = [];
        this.state = false;
        this.filteredSamples = [];
    }
    async loadResources() {
        const samplesPaginator = LaravelAPIPaginator_1.default.get('/samples/api', undefined, undefined, this.samples);
        const cropsPaginator = LaravelAPIPaginator_1.default.get('/crop/api', undefined, undefined, this.crops);
        Promise.all([
            samplesPaginator.all(function (sample) {
                return Sample_1.default.fromJson(sample);
            }),
            cropsPaginator.all(function (crop) {
                return Crop_1.default.fromJson(crop);
            }),
        ]);
        let stat = this.state;
        setTimeout(function () {
            stat = !stat;
        }, 2000);
        this.filteredSamples = this.samples;
    }
    created() {
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        if (this.raw_would_rather_crops) {
            this.would_rather_crops = Object.values(this.raw_would_rather_crops).map((raw) => Crop_1.default.fromJson(raw));
        }
        this.loadResources();
    }
    mounted() { }
    validation() {
        let incomplete = 0;
        let boo = [];
        let val = null;
        for (const sample of this.samples) {
            if (sample.parcel == null) {
                incomplete += 1;
                boo.push(1);
            }
            if (boo.length == 0) {
                val = false;
            }
            else {
                val = true;
            }
        }
        return { val, incomplete };
    }
    filterSamples(f) {
        if (f.length > 0) {
            this.filteredSamples = this.samples
                .filter((s) => s.c_muestra_wineseq.toUpperCase().includes(f.toUpperCase()) ||
                s.client_reference.toUpperCase().includes(f.toUpperCase()) ||
                (0, moment_1.default)(s.fecha_muestra)
                    .format('DDMMMMYYYY')
                    .toString()
                    .toUpperCase()
                    .includes(f.toUpperCase())
            // TODO: -------------------- Filter Name Parcel --------------------
            /*
            || s.parcel != null
             s.parcel.toUpperCase().includes(f.toUpperCase())
            : ""
             */
            // TODO: -------------------- Filter Name Parcel --------------------
            )
                .map((sam) => sam);
        }
        else {
            this.filteredSamples = this.samples;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsView.prototype, "filter_list", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsView.prototype, "raw_user", void 0);
ReportsView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            NumberReports: NumberReports_vue_1.default,
            Search: Search_vue_1.default,
            TableReports: TableReports_vue_1.default,
            NotificationBanner: NotificationBanner__vue_1.default,
            ReportsFooter: ReportsFooter_vue_1.default,
            HelpGuide: HelpGuide_vue_1.default,
            SearchOptions: SearchOptions_vue_1.default,
            ZeroView: ZeroView_vue_1.default,
            ViewZero: ViewZero_vue_1.default,
            Distributor: Distributor_vue_1.default,
            Loader: Loader_vue_1.default,
            DistributorBanner: DistributorBanner_vue_1.default,
        },
    })
], ReportsView);
exports.default = ReportsView;
